import formMapper from "@mappers/Modules/webinar/WebinarItem.mapper";
import createItemAPI from "@services/Webinar/createWebinar";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/webinar/webinar.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
